module.exports = __webpack_public_path__ + "img/subprocess.363cde32.svg";